export var planLengthsFixed = {
    SATELLITE: [
        {
            name: '30days',
            display_name: '30 days notice',
            description: 'No lock-in',
        },
        {
            name: '12months',
            display_name: '12 month',
            description: 'Lock-in to unlock extra anytime and off-peak data at no additional cost',
            hide_for_plan_type: 'skymusterPlus',
        }
    ],
    WIRELESS: [
        {
            name: '30days',
            display_name: '30 days notice',
        }
    ]
};
export var planTypesFixed = {
    SATELLITE: [
        {
            title: 'Sky Muster™',
            description: 'Sky Muster™ plans capped with a monthly anytime and off-peak allowance.',
            code: 'skymusterBasic',
        },
        {
            title: 'Sky Muster™ Plus',
            description: 'Includes Unmetered Content like Social Media, Video Calling, Audio Streaming and Gaming.',
            code: 'skymusterPlus',
            plan_length: '30days',
            is_new: true,
        },
        {
            title: 'Sky Muster™ Education',
            description: '',
            code: 'skymusterEducation',
            is_hidden: true,
        }
    ]
};
// This is used with API to provide more readable plan cards
export var speedTiersFixed = {
    SATELLITE: {
        '12/1 Mbps': {
            contract_length: '30days',
            title: 'Basic Evening Speed',
            explanation: 'Everyday broadband for browsing and emails.',
            plan_type: 'skymusterBasic',
        },
        '25/5 Mbps': {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse, stream online video, email and update software.',
            plan_type: 'skymusterBasic',
        },
        '12/1 Mbps (OWL)': {
            contract_length: '30days',
            title: 'Basic Evening Speed',
            explanation: '<strong>Night Owl</strong><br> Everyday off-peak broadband for browsing and emails.',
            is_disabled: true,
            is_hidden: true,
        },
        '25/5 Mbps (OWL)': {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: '<strong>Night Owl</strong><br> Everyday off-peak broadband for browsing and emails.',
            is_disabled: true,
            is_hidden: true,
        },
        SKYMESH_12_MONTH_12_1: {
            contract_length: '12months',
            title: 'Basic Evening Speed',
            explanation: 'Everyday broadband for browsing and emails.',
            plan_type: 'skymusterBasic',
        },
        SKYMESH_12_MONTH_25_5: {
            contract_length: '12months',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse, stream online video, email and update software.',
            plan_type: 'skymusterBasic',
        },
        STUDENT_12_1: {
            contract_length: '30days',
            title: 'Basic Evening Speed',
            explanation: 'Every day broadband for browsing and emails.',
            plan_type: 'skymusterEducation',
        },
        STUDENT_25_5: {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse, stream online video, email and update software.',
            plan_type: 'skymusterEducation',
        },
        SMP: {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse and stream content. Some unmetered content may be shaped during evenings.',
            plan_type: 'skymusterPlus',
        }
    },
    WIRELESS: {
        '12/1 Mbps': { is_hidden: true, is_disabled: true },
        '25/5 Mbps': { is_hidden: true, is_disabled: true },
        '50/20 Mbps': { is_hidden: true, is_disabled: true },
        SKYMESH_WIRELESS_2019: {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse, stream online video and email.',
            speed_tier: 'SKYMESH_WIRELESS_2019',
            is_hidden: true,
        },
        SKYMESH_WIRELESS_2020: {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse, stream online video and email.',
            speed_tier: 'SKYMESH_WIRELESS_2020',
            is_hidden: true,
        },
        SKYMESH_WIRELESS_2021: {
            contract_length: '30days',
            title: 'Standard Evening Speed',
            explanation: 'Fast broadband to browse, stream online video and email.',
            speed_tier: 'SKYMESH_WIRELESS_2021',
            is_hidden: true,
        },
    }
};
